import * as React from 'react'
import {
  Text,
  Colors,
  Spacing,
  Stack,
  StackChildren,
  InlineChildren,
} from '@doordash/design-language'
import t from './strings'
import Form from '../../../../utilities/Form'
import Button from '@doordash/component-button'
import Toggle from '@doordash/component-toggle'
import { validators as sharedValidators } from '../../../../utilities/validators'
import { BirthdateInputSplit, DateFormat } from '../../../atoms/birthdate-input'
import { VehicleTypeDropdown } from '../../../atoms/vehicle-type-dropdown'
import { connect } from 'react-redux'

import { HorizontalContainer } from './styles'
import { ErrorMessage } from '@doordash/component-fields'

type Props = {
  uniqueLink?: string
  doSubmit?: (uniqueLink: string, backgroundInfo: object) => Promise<any>
  vehicleTypes?: any
  application?: any
}

class Japan extends React.Component<Props> {
  public static fields = {
    vehicleType: -1,
    birthday: '',
    citizenship: undefined,
  }
  public static validators = {
    vehicleType: sharedValidators.vehicleType,
    birthday: sharedValidators.birthday,
    citizenship: sharedValidators.radioButtonGroup,
  }

  handleSubmit = async (data) => {
    const { doSubmit, uniqueLink } = this.props
    try {
      return await doSubmit(uniqueLink, data)
    } catch (e) {
      console.warn(e)
    }
  }

  processVehicleTypes = vehicleTypes => {
    return Object.keys(vehicleTypes).map(key => ({...vehicleTypes[key], value: key}))
  }

  render() {
    const { vehicleTypes, application } = this.props
    return (
      <React.Fragment>
        <StackChildren size={Spacing.Large}>
          <Text color={Colors.SystemRed60} styles={Text.Styles.MajorPageTitle}>
            {t.title()}
          </Text>
          <Text
            lineHeights={Text.LineHeights.XxxLarge}
            color={Text.Colors.TextTertiary}
            weight={Text.Weights.Regular}
          >
            {t.vehicleExplanation()}
          </Text>
          <Form
            onSubmit={this.handleSubmit}
            validators={Japan.validators}
            fields={Japan.fields}
          >
            {(fields, handleChange, handleSubmit, { isLoading }) => (
              <form onSubmit={handleSubmit}>
                <StackChildren size={Spacing.XLarge}>
                  <VehicleTypeDropdown
                    label={t.vehicleTypeLabel().concat('*')}
                    vehicleTypes={this.processVehicleTypes(vehicleTypes)}
                    onChange={handleChange.bind(this, 'vehicleType')}
                    {...fields.vehicleType}
                  />
                  <BirthdateInputSplit
                    id="birthdate-input-split"
                    label={t.birthdate().concat('*')}
                    onChange={handleChange.bind(this, 'birthday')}
                    birthdayField={fields.birthday}
                    format={DateFormat.YEAR_MONTH_DAY}
                    noDescription={true}
                    locale={'JP'}
                    {...fields.birthday}
                  />
                  <StackChildren size={Spacing.XxSmall}>
                    <Text
                      lineHeights={Text.LineHeights.Medium14}
                      color={Text.Colors.TextPrimary}
                      weight={Text.Weights.Regular}
                    >
                      {t.jpnCitizenshipTitle()}
                    </Text>
                    <Text
                      lineHeights={Text.LineHeights.Medium14}
                      color={Text.Colors.TextTertiary}
                      weight={Text.Weights.Regular}
                    >
                      {t.jpnCitizenshipParagraph()}
                    </Text>
                  </StackChildren>
                  <StackChildren size={Spacing.XxxxSmall}>
                    <HorizontalContainer size={InlineChildren.Sizes.XxSmall} alignItems={InlineChildren.Alignment.FlexStart}                  >
                      <Toggle
                          isSelected={fields.citizenship.value !== undefined && fields.citizenship.value}
                          type={Toggle.Types.Radio}
                          label={t.yes()}
                          onChange={handleChange.bind(this, 'citizenship', application.country)}
                        />
                        <Toggle
                          isSelected={fields.citizenship.value !== undefined && !fields.citizenship.value}
                          type={Toggle.Types.Radio}
                          label={t.no()}
                          onChange={handleChange.bind(this, 'citizenship', '')}
                        />
                    </HorizontalContainer>
                    {fields.citizenship.error && <ErrorMessage error={fields.citizenship.error} />}
                  </StackChildren>
                  <StackChildren size={Spacing.XLarge}>
                    <Stack size={Spacing.Large} />
                    <Button
                        onClick={handleSubmit}
                        state={
                          isLoading ? Button.States.Loading : Button.States.Default
                        }
                    >
                      {t.continue()}
                    </Button>
                  </StackChildren>
                </StackChildren>
              </form>
            )}
          </Form>
        </StackChildren>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  application: state.application,
})

export default connect(mapStateToProps)(Japan)